// extracted by mini-css-extract-plugin
export var aboveInput = "_ls-0";
export var actionButton = "_ls-5";
export var actionButtonContainer = "_ls-1";
export var actionIcon = "_ls-6";
export var aiInfoContainer = "_ls-2";
export var attachmentWrapper = "_ls-7";
export var bold = "_ls-3";
export var checkIcon = "_ls-8";
export var clickingRecipientBar = "_ls-11";
export var commentThreadSwitch = "_ls-a";
export var draftImage = "_ls-b";
export var draftImageContainer = "_ls-c";
export var draftImages = "_ls-e";
export var editButton = "_ls-g";
export var editor = "_ls-f";
export var editorContainer = "_ls-y";
export var editorErrorTooltipWrapper = "_ls-9";
export var headerDivider = "_ls-h";
export var icon = "_ls-i";
export var info = "_ls-j";
export var internal = "_ls-n";
export var internalDivider = "_ls-k";
export var internalMessage = "_ls-l";
export var messageInputCard = "_ls-m";
export var messageInputForm = "_ls-o";
export var messageInputFormInternal = "_ls-p";
export var options = "_ls-q";
export var publicMessageCustomer = "_ls-s";
export var publicMessageMerchant = "_ls-r";
export var removeImageButton = "_ls-d";
export var replyButtons = "_ls-t";
export var showSignatureButton = "_ls-u";
export var spinner = "_ls-v";
export var verticalButtonDivider = "_ls-4";
export var visibilitySelector = "_ls-w";
export var warning = "_ls-x";
export var wrappingText = "_ls-z";
export var writingInternalNoteTopBorder = "_ls-10";